import { BankRepository } from "../infra/SettingsRepository";




export class SaveBankSettingsCommand {
    constructor(private readonly repository: BankRepository, private readonly frontend) {}

    async run(): Promise<void> {        
        this.frontend.bankSetting['payload']['hide'] = this.frontend.bankDialogHide
        this.frontend.bankSetting['payload']['show'] = this.frontend.bankDialogShow
        let settings = this.repository.api_to_domain(this.frontend.bankSetting)

        await this.repository.save(settings)

        this.frontend.popupBankDialog = false
        this.frontend.isLoading = false
    }
}





